import React, { FC } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faAngleDown,
} from '@fortawesome/free-solid-svg-icons';
type AccordionProps = {
  i: number;
  expanded: false | number;
  setExpanded: (value: false | number) => void;
  title?: string;
};

const Accordion: FC<AccordionProps> = ({
  i,
  expanded,
  setExpanded,
  children,
  title,
}) => {
  const isOpen = i === expanded;

  return (
    isOpen ? (
      <>
        <motion.header
          initial={false}
          //animate={{ backgroundColor: isOpen ? '#d8bd55' : '#2b2b2b' }}
          onClick={() => setExpanded(i)}
        >
          <div className={isOpen ? "section_title active" : "section_title"}>
            שלב {i + 1}: {title}
            <FontAwesomeIcon
              icon={isOpen ? faAngleLeft : faAngleDown}
              color={isOpen ? '#000' : '#fff'}
            />
          </div>
        </motion.header>
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.section
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
            >
              {children}
            </motion.section>
          )}
        </AnimatePresence>
        <div className="navigation">
          {i !== 0 ? (
            <div className="nav_btn back" onClick={() => {setExpanded(i - 1); window.scrollTo(0, 0)}}>
              <FontAwesomeIcon icon={faAngleRight} />
              הקודם
            </div>
            ) : (null)}
          {i !== 2 ? (
            <div className="nav_btn next" onClick={() => {setExpanded(i + 1); window.scrollTo(0, 0)}}>
              הבא
              <FontAwesomeIcon icon={faAngleLeft} />
            </div>
            ) : (null)}
        </div>
      </>
    ) : (null)
  );
};

export default Accordion;
